import * as ActionTypes from '../constants/utilConstants'


export const SinginNextRoute = (route) => dispatch => {
    dispatch({ type: ActionTypes.SIGIN_NEXT_ROUTE, payload: route })
}
export const ShippingNextRoute = (route) => dispatch => {
    dispatch({ type: ActionTypes.SHIPPING_NEXT_ROUTE, payload: route })
}
